import Vue from 'vue'
import VueJsonPretty from 'vue-json-pretty'

Vue.component('VueJsonPretty', VueJsonPretty)
